module.exports = __webpack_public_path__ + "site/img/indexnewyear2en.d14ef516.png";